import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NEW_SERIES_SA } from '../../models/seriessa';
import { SERIES, SERIES_REDEEM, VW_SERIES } from '../../models/series';
import { BIDS } from '../../models/issuance';
import { HeaderService } from '../../header.service';
import { APP_USERS } from '../../models/user';
import * as Globals from '../../globals';
import { TargetLocator } from 'selenium-webdriver';

declare var $: any;

@Component({
  selector: 'app-series-sa',
  templateUrl: './series-sa.component.html',
  styleUrls: ['./series-sa.component.css']
})
export class SeriesSaComponent implements OnInit {

  @Input() userProfile: any;
  @Input() cdAucType: string;
  loading: boolean = false;  
  @Input() ssId: number;
  @Input() seriesId: number;
  @Input() seriesData: SERIES;
  @Input() authMenu: any;
  @Input() parentSsId: number;
  @Input() series: SERIES;
  part: any[];
  cds:any[];
  p: number = 1;
  tipeMidis: string;
  seriessa: NEW_SERIES_SA;
  seriessaTarget:number;
  totalBidP:number;
  totalBidNP:number;
  sumBidAmt:number;
  // bidsNP:BIDS[];
  bidsInfo:any;
  appUser: APP_USERS;
  confirmBy: string = '';
  @Output() refreshSeries = new EventEmitter;
  @Output() refreshSubAgentList = new EventEmitter;
  constructor(
    private http: Http,
    public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService
  ) {
    this.toastr.setRootViewContainerRef(vRef);
  }

  ngOnInit() {
    this.newSeriessa();
    this.getPart();    
    this.getTotalBidP();
    this.getTotalBidNP();
    // this.getBidsNP();
  }  

  newSeriessa() {
    this.seriessa = new NEW_SERIES_SA(null, null, 0, null, null, 0, this.userProfile.USER_ID, null, null, null, null);    
  }

  getSeriesSa() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/seriessa?Id=' + this.ssId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.seriessa = res.json();
        this.seriessaTarget = this.seriessa.TARGET;
        this.getCds(this.seriessa.CG_INST_TYPE);
        // this.getUser(this.seriessa.CONFIRM_BY);
        this.getUser(this.userProfile.USER_ID);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getTotalBidP() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/totalbidspbyap?ssId=' + this.ssId, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.totalBidP = res.json();         
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getTotalBidNP() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/totalbidsnpbyap?ssId=' + this.ssId, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.totalBidNP = res.json();         
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getCds(cgNo: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=' + cgNo + '&t' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.cds = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getUser(userId: number) {
    this.http.get(Globals.serviceUrl + 'ref/user?id=' + userId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.appUser = res.json();
          if (userId == this.appUser.USER_ID) {
            this.confirmBy = this.appUser.USERNAME;
          }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getPart() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=1&search='+ '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.part = res.json();
        // alert(this.ssId);
        if (this.ssId > 0) {
          for (var i = 0; i < this.part.length; i++) {  
            if (this.ssId == this.part[i].PA_ID) {
                this.getCds(this.part[i].CG_INST_TYP);
            }
          }
          this.getSeriesSa();
        }
        else {
          this.getCds(17);
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  loadParent(val: any) {
    if (this.parentSsId == 0) {
      this.refreshSeries.emit({ ssId: this.seriessa.SS_ID, saCode: this.seriessa.SA_CODE, mode: val });
    } else {
      this.refreshSubAgentList.emit({ ssId: this.seriessa.SS_ID, saCode: this.seriessa.SA_CODE, mode: val });
    }

  }

  saveSeriessa() {
    this.loading = true;    
    if (this.parentSsId > 0) {
      this.seriessa.PARENT_ID = this.parentSsId;
    }
    else if(this.seriessa.TARGET % this.seriesData.INCREMENTAL !== 0 ){
      this.toastr.error('Target harus sesuai kelipatan '+this.seriesData.INCREMENTAL);     
      this.seriessa.TARGET = this.seriessaTarget; 
      this.loading = false;
    }
    else if(this.seriessa.TARGET < this.totalBidP){
      this.toastr.error('Target harus lebih besar atau sama dengan total pemesanan Prioritas yang sudah dikonfirm');     
      this.seriessa.TARGET = this.seriessaTarget; 
      this.loading = false;
    }

    else{
      if (this.ssId == 0) {
        this.saveNewSeriesSA();
      } else {
        this.updateSeriesSA();
      }
    }
    
  }

  saveNewSeriesSA(){
    this.seriessa.SERIES_ID = this.seriesId;
      this.seriessa.CG_INST_TYPE = 17;
      this.http.post(Globals.serviceUrl + 'ritel/seriessa', this.seriessa, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.seriessa = res.json();
          this.toastr.success('Data berhasil disimpan');
          this.ssId = this.seriessa.SS_ID;
          this.loadParent(1);
          this.getSeriesSa();
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
  }

  updateSeriesSA(){
    this.seriessa.CG_INST_TYPE = 17;
        this.http.put(Globals.serviceUrl + 'ritel/seriessa?id=' + this.seriessa.SS_ID, this.seriessa, { headers: this.headerService.getHeader() })
          .subscribe((res: Response) => {
            this.toastr.success('Data berhasil disimpan');
            this.loadParent(1);
            this.getSeriesSa();            
            this.loading = false;
          }, err => {
            console.log(err);
            this.toastr.error(Globals.errorMessage(err));
            this.loading = false;
          });
  }

  simulasiUpsize(){      
    this.loading = true;    
    if (this.parentSsId > 0) {
      this.seriessa.PARENT_ID = this.parentSsId;
    }
    else if(this.seriessa.TARGET % this.seriesData.INCREMENTAL !== 0 ){
      this.toastr.error('Target harus sesuai kelipatan '+this.seriesData.INCREMENTAL);     
      this.seriessa.TARGET = this.seriessaTarget; 
      this.bidsInfo = null;
      this.loading = false;
    }
    else if(this.seriessa.TARGET < this.totalBidP){
      this.toastr.error('Target harus lebih besar atau sama dengan total pemesanan Prioritas yang sudah dikonfirm');     
      this.seriessa.TARGET = this.seriessaTarget; 
      this.bidsInfo = null;
      this.loading = false;
    }
    else if(this.seriessaTarget == this.seriessa.TARGET){
      this.updateSeriesSA();
      this.bidsInfo = null;
    }
    else {
      this.calculationNP();
    }
      
  }

  prosesUpsize(){      
    this.loading = true;    
    if (this.parentSsId > 0) {
      this.seriessa.PARENT_ID = this.parentSsId;
    }
    else if(this.seriessa.TARGET % this.seriesData.INCREMENTAL !== 0 ){
      this.toastr.error('Target harus sesuai kelipatan '+this.seriesData.INCREMENTAL);     
      this.seriessa.TARGET = this.seriessaTarget; 
      this.bidsInfo = null;
      this.loading = false;
    }
    else if(this.seriessa.TARGET < this.totalBidP){
      this.toastr.error('Target harus lebih besar atau sama dengan total pemesanan Prioritas yang sudah dikonfirm');     
      this.seriessa.TARGET = this.seriessaTarget; 
      this.bidsInfo = null;
      this.loading = false;
    }
    else if(this.seriessaTarget == this.seriessa.TARGET){
      this.updateSeriesSA();
      this.bidsInfo = null;
    }
    else {
      this.submitUpsize();
    }
      
  }

  submitUpsize(){
    this.http.get(Globals.serviceUrl + 'ritel/prosesUpsize?oldTarget='+this.seriessaTarget+'&newTarget='+this.seriessa.TARGET+'&ssId='+this.ssId, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          //this.bidsInfo = res.json();          
          //this.toastr.success('Data berhasil disimpan');
            //this.loadParent(1);
            //this.getSeriesSa();                  
          //this.loading = false;
          this.getTotalBidNP();
          this.getTotalBidP();
          this.updateSeriesSA();
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
  }

  calculationNP(){
    this.http.get(Globals.serviceUrl + 'ritel/simulasiUpsize?oldTarget='+this.seriessaTarget+'&newTarget='+this.seriessa.TARGET+'&ssId='+this.ssId, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.bidsInfo = res.json();          
          //this.toastr.success('Data berhasil disimpan');
          //this.ssId = this.seriessa.SS_ID;
          //this.loadParent(1);
          //this.getSeriesSa();
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
  }

  resetTarget(){
    this.getSeriesSa();
    this.getTotalBidP();
    this.getTotalBidNP();
    this.bidsInfo = null;
  }

  deleteSeriessa() {
    this.http.delete(Globals.serviceUrl + 'ritel/seriessa?id=' + this.seriessa.SS_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        this.loadParent(0);
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/auction/series-sa/series-sa.component.ts